import { useMutation } from "@tanstack/react-query";
import type { CheckoutEstimateReturnRequestDto, CheckoutEstimateResultDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { SESSION_TOKEN_KEY } from "./use-session-token";

export async function publicCheckoutEstimate(
  payload: CheckoutEstimateReturnRequestDto,
): Promise<CheckoutEstimateResultDto> {
  const token = localStorage.getItem(SESSION_TOKEN_KEY) ?? "";
  const { data, response } = await getReturnWidgetFetchClient().POST(
    "/public/return-request/checkout/estimate",
    {
      body: payload,
      params: { header: { authorization: `Bearer ${token}` } },
    },
  );
  if (!response.ok) throw new Error("Failed to fetch shipping rates");
  if (!data) throw new Error("No data returned from checkout estimate");
  return data;
}

export function usePublicCheckoutEstimate() {
  return useMutation({ mutationFn: publicCheckoutEstimate });
}
